import { ModulesMap, ModulesConfigMap } from '../modulesMaps'

export default {
	[ModulesConfigMap[ModulesMap.CARGO_TAGS].GET_CARGO_TAGS]: {
		url: '/company/:companyId/cargo_tags/',
	},

	[ModulesConfigMap[ModulesMap.CARGO_TAGS].GET_CARGO_TAG]: {
		url: '/company/:companyId/cargo_tags/:cargoTagId/',
	},

	[ModulesConfigMap[ModulesMap.CARGO_TAGS].CREATE_CARGO_TAG]: {
		url: '/company/:companyId/cargo_tags/',
		requestOptions: {
			method: 'POST',
		},
	},

	[ModulesConfigMap[ModulesMap.CARGO_TAGS].PUT_CARGO_TAG]: {
		url: '/company/:companyId/cargo_tags/:cargoTagId/',
		requestOptions: {
			method: 'PUT',
		},
	},

	[ModulesConfigMap[ModulesMap.CARGO_TAGS].PATCH_CARGO_TAG]: {
		url: '/company/:companyId/cargo_tags/:cargoTagId/',
		requestOptions: {
			method: 'PATCH',
		},
	},

	[ModulesConfigMap[ModulesMap.CARGO_TAGS].DELETE_CARGO_TAG]: {
		url: '/company/:companyId/cargo_tags/:cargoTagId/',
		requestOptions: {
			method: 'DELETE',
		},
	},

}